<template>
	<b-tabs>
		<b-tab v-for="(cat, $catIndx) in cats" :title="cat" :key="cat" :active="tipo_clasificador == cat" @click="tipo_clasificador = cat">
			<div class="text-center p-5" v-if="isUpdating">
				<b-spinner variant="primary" label="Spinning"></b-spinner>
			</div>
			<template v-else>
				<!-- {{simplifiedValue}} -->
				<b-list-group v-if="filtered.length">
						
					<b-list-group-item v-for="filter in filtered" :key="$catIndx + '-' + filter.id">
						<b-form-checkbox :checked="(simplifiedValue.indexOf(filter.id) != -1)" switch size="lg" @change="toggle(filter.id)">
							{{filter.clasificador}} 
							<!-- - {{filter.id}} -->
							<ui-edit-auto-modal btn-class="btn btn-link text-secondary" key="new" :refresh="refresh" :formArchetype="formArchetype" ref="main" :handler="'define/source/planclasificadores/' + filter.id" apply-button="Actualizar" size="md" deleteDisclaimer="Si borras ésta subcategoría, se borrará también para otros menús que la tengan asignada.">
								<i class="fa fa-pencil"></i>
							</ui-edit-auto-modal>
						</b-form-checkbox>
					</b-list-group-item>

				</b-list-group>
				<b-jumbotron v-else header="No hay categorias disponibles" lead="Agrega una en el botón inferior" />
				<hr	 />
				<div class="text-right">
					<ui-edit-auto-modal key="new" :refresh="refresh" :formArchetype="formArchetype" ref="main" label="Registrar subcategoria" handler="define/source/planclasificadores" apply-button="Aplicar" size="md" />
				</div>
			</template>
		</b-tab>
	</b-tabs>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'

let cats = ["Nacionalidad", "Régimen", "Calorías", "Temporada", "Padecimiento"];
let subcatsQueryAPI = "paginate/table/planclasificadores/1000"; // LIMITE 1000... Deberian ser eternamente menos que eso.
let formArchetype = [
	{ key: "id", type: "hidden" },
	{ key: "tipo_clasificador", label: 'Tipo', type: "hidden", options:cats, required: true, default: cats[0] },
	{ key: "clasificador", label: 'Subcategoría', required: true },
];

export default {
	name: "menu-categorizacion",
	props: {
		value: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
    computed: {
		simplifiedValue(){
			let simp = []
			_.forEach(this.value, item => {
				simp.push(item.planclasificadores_id)
			})
			return simp
		},
        filtered(){
            return _.sortBy(_.filter(this.indexData, {tipo_clasificador: this.tipo_clasificador}), ['clasificador'], ['ASC'])
        }
    },
	data: () => {
		return {
			isUpdating: false,
			indexData: [],
			cats,
            formArchetype: _.clone(formArchetype),
			tipo_clasificador: cats[0]
		};
	},
	methods: {
		toggle(id){
			let data = _.clone(this.value),
				indxOfId = _.findIndex(data, {planclasificadores_id: id})
			if( indxOfId == -1){
				data.push({planclasificadores_id: id})
			} else {
				data.splice(indxOfId, 1)
			}
			this.$emit('input', data)
		},
        async refresh(){
            this.isUpdating = true;
            await this.loadUp();
            this.isUpdating = false;
        },
		async loadUp() {
			try {
				let response = await axios.get(subcatsQueryAPI);
					console.log("resp", response);
				if (response.status === false) {
					throw "Ocurrió un error de lectura";
				} else {
                    this.indexData = response.data.rows
				}
			} catch (e) {
				console.error(e);
				mobiscroll.snackbar({
					display: "top",
					theme: "ios",
					message: "Ocurrió un error obteniendo la respuesta: " + e,
					color: "warning",
					duration: 7000,
				});
			}
		},
	},
	mounted() {
        this.refresh()
	},
	watch: {
		tipo_clasificador(){
			let indx = _.findIndex(formArchetype, {key: 'tipo_clasificador'})
			console.log('watch', indx)
			this.formArchetype[indx].default = this.tipo_clasificador
		}
	}
};
</script>

<style lang="less">
.menu-categorizacion {
}
</style>